/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-28 09:52:05
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-11-10 10:18:20
 */
import i18n from "@/config/i18n";
const regular = {
    towNumber: /^(\d+|\d+\.\d{1,2})$/,
    phone: /^1[3456789]\d{9}$/,
    userName: /^[a-zA-Z0-9][a-zA-Z0-9_]*$/,
    name: /^[a-zA-Z0-9_()\u4e00-\u9fa5]+$/,
    email: /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
    tel: /[^0-9-]+/,
    numAB: /^[0-9a-zA-Z]+$/,
    numABArrStr: /^[0-9a-zA-Z,]+$/,
    number: /^[0-9]+$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\S]{8,16}$/,
};
const validate = {
    regularData: regular,
    towNumber: /^(\d+|\d+\.\d{1,4})$/,
    name(rule, value, callback) {
        const name = rule.name || i18n.t("regular.name");
        const max = rule.max || 20;
        const min = rule.min || 1;
        if (value === "") {
            callback(new Error(i18n.t("regular.please") + name));
        }
        else if (value.length > max) {
            callback(new Error(name + i18n.t("regular.max") + max + i18n.t("regular.maxText")));
        }
        else if (value.length < min) {
            callback(new Error(name + i18n.t("regular.min") + min + i18n.t("regular.maxText")));
        }
        else {
            callback();
        }
    },
    abcNumber(rule, value, callback) {
        const name = rule.name || i18n.t("regular.name");
        const max = rule.max || 20;
        const min = rule.min || 1;
        const reg = regular.numAB;
        if (value === "") {
            callback(new Error(i18n.t("regular.please") + name));
        }
        else if (value.length > max) {
            callback(new Error(name + i18n.t("regular.max") + max + i18n.t("regular.maxText")));
        }
        else if (value.length < min) {
            callback(new Error(name + i18n.t("regular.min") + min + i18n.t("regular.maxText")));
        }
        else if (rule.len && value.length != rule.len) {
            callback(new Error(name + rule.len + i18n.t("regular.maxText")));
        }
        else if (!reg.test(value)) {
            callback(new Error(name + i18n.t("regular.numberABC")));
        }
        else {
            callback();
        }
    },
    userName(rule, value, callback) {
        const name = rule.name || i18n.t("regular.name");
        const max = rule.max || 20;
        const min = rule.min || 1;
        const reg = regular.userName;
        if (value === "") {
            callback(new Error(i18n.t("regular.please") + name));
        }
        else if (value.length > max) {
            callback(new Error(name + i18n.t("regular.max") + max + i18n.t("regular.maxText")));
        }
        else if (value.length < min) {
            callback(new Error(name + i18n.t("regular.min") + min + i18n.t("regular.maxText")));
        }
        else if (!reg.test(value)) {
            callback(new Error(name + i18n.t("regular.number_ABC")));
        }
        else {
            callback();
        }
    },
    tel(rule, value, callback) {
        const reg = regular.tel;
        if (rule.type === "valueNull") {
            if (value === "" || !value) {
                callback();
            }
            else if (reg.test(value) || value.length < 7 || value.length > 15) {
                callback(new Error(i18n.t("regular.tel") + ""));
            }
            else {
                callback();
            }
        }
        else {
            if (value === "") {
                callback(new Error(i18n.t("regular.phone") + ""));
            }
            else if (reg.test(value) || value.length < 7 || value.length > 15) {
                callback(new Error(i18n.t("regular.tel") + ""));
            }
            else {
                callback();
            }
        }
    },
    phone(rule, value, callback) {
        const reg = regular.phone;
        if ((rule.type === "valueNull" && value === "") ||
            (rule.type === "valueNull" && !value)) {
            callback();
        }
        else if (value === "") {
            callback(new Error(i18n.t("regular.phone") + ""));
        }
        else if (value.length != 11) {
            callback(new Error(i18n.t("regular.phonePl11") + ""));
        }
        else if (!reg.test(value)) {
            callback(new Error(i18n.t("regular.phoneError") + ""));
        }
        else {
            callback();
        }
    },
    int(rule, value, callback) {
        const name = rule.name || "";
        const reg = regular.number;
        if ((rule.type === "valueNull" && value === "") ||
            (rule.type === "valueNull" && !value)) {
            callback();
        }
        else if (value === "") {
            callback(new Error(i18n.t("regular.please") + name));
        }
        else if (!reg.test(value)) {
            callback(new Error(name + i18n.t("regular.int")));
        }
        else if (rule.maxlength && value.length > rule.maxlength) {
            callback(new Error(name +
                i18n.t("regular.maxInput") +
                rule.maxlength +
                i18n.t("regular.unit")));
        }
        else if (rule.minlength && value.length < rule.minlength) {
            callback(new Error(name +
                i18n.t("regular.minInput") +
                rule.minlength +
                i18n.t("regular.unit")));
        }
        else if (rule.max && value > rule.max) {
            callback(new Error(name + i18n.t("regular.maxNum") + rule.max));
        }
        else if (rule.min != undefined && value < rule.min) {
            callback(new Error(name + i18n.t("regular.minNum") + rule.min));
        }
        else {
            callback();
        }
    },
    money(rule, value, callback) {
        const reg = regular.towNumber;
        const name = rule.name || i18n.t("regular.money");
        if (value === "") {
            callback(new Error(i18n.t("regular.please") + name));
        }
        else if (!reg.test(value)) {
            callback(new Error(name + i18n.t("regular.towDecimal" + "")));
        }
        else if (rule.max && value > rule.max) {
            callback(new Error(name + i18n.t("regular.maxNum") + rule.max));
        }
        else if (rule.min && value < rule.min) {
            callback(new Error(name + i18n.t("regular.minNum") + rule.min));
        }
        else {
            callback();
        }
    },
    emailRegular(rule, value, callback) {
        const max = rule.max || 50;
        const reg = regular.email;
        if (value === "") {
            callback(new Error(i18n.t("regular.email") + ""));
        }
        else if (value.length > max) {
            callback(new Error(i18n.t("regular.emailPl") + max + i18n.t("regular.maxText")));
        }
        else if (!reg.test(value)) {
            callback(new Error(i18n.t("regular.emailError") + ""));
        }
        else {
            callback();
        }
    },
    time(rule, value, callback) {
        if (value[0] == "") {
            callback(new Error(i18n.t("formText.selectTimePl") + ""));
        }
        else if (Date.parse(value[0]) > Date.parse(value[1])) {
            callback(new Error(i18n.t("formText.tipsMaxTime") + ""));
        }
        else {
            callback();
        }
    },
    password(rule, value, callback) {
        const reg = regular.password;
        if (value == "") {
            callback(new Error(i18n.t("regular.passwordPl") + ""));
        }
        else if (!reg.test(value)) {
            callback(new Error(i18n.t("regular.passwordError") + ""));
        }
        else {
            callback();
        }
    },
};
export default validate;
